
import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ContactMethodProps {
  type: string;
  value: string;
  icon: LucideIcon;
  href: string;
  subtitle?: string;
}

const ContactMethod = ({ type, value, icon: Icon, href, subtitle }: ContactMethodProps) => {
  return (
    <Card className="group hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border-2 hover:border-nexx-green">
      <CardContent className="p-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-nexx-green rounded-full group-hover:scale-110 transition-transform duration-300">
            <Icon className="h-5 w-5 text-white" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-gray-900 text-sm">{type}</h4>
            <a 
              href={href}
              className="text-nexx-green hover:text-green-700 transition-colors font-medium"
            >
              {value}
            </a>
            {subtitle && (
              <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
            )}
          </div>
          <Button 
            asChild
            size="sm"
            className="bg-nexx-green hover:bg-green-700 group-hover:scale-105 transition-transform duration-300"
          >
            <a href={href}>
              Contact
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ContactMethod;
